import history from 'dashboard/history';
import GoogleTagManager     from 'lib/GoogleTagManager';
import AppsSelector         from 'components/Sidebar/AppsSelector.react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button               from 'components/Button/Button.react';
import SidebarHeader        from 'components/Sidebar/SidebarHeader.react';
import SidebarSection       from 'components/Sidebar/SidebarSection.react';
import SidebarSubItem       from 'components/Sidebar/SidebarSubItem.react';
import SidebarUserMenu      from 'components/Sidebar/SidebarUserMenu.react';
import styles               from 'components/Sidebar/Sidebar.scss';
import moment               from 'moment';

export default class Sidebar extends Component {
  _subMenu(subsections) {
    if (!subsections) {
      return null;
    }

    return (
      <div className={styles.submenu}>
        {subsections.map((section) => {
          let active = this.props.subsection === section.name;
          return (
            <SidebarSubItem
              router={this.props.router}
              key={section.name}
              name={section.name}
              icon={section.icon}
              link={(this.props.prefix || '') + section.link}
              action={this.props.action || null}
              actionHandler={active ? this.props.actionHandler : null}
              active={active}
              newFeature={section.newFeature}
              betaFeature={section.betaFeature}
            >
              {active ? this.props.children : null}
            </SidebarSubItem>
          );
        })}
      </div>
    );
  }

  addCard = () => {
    history.push(this.props.currentCustomer.has_payment_method ? `/billing` : `/billing/add_card`);
  }

  isTrialFn = () => {
    const { currentUser, currentCustomer } = this.props;
    const { email } = currentUser;
    const { is_trial } = currentCustomer;

    const isTrial = is_trial && !email.includes('@cloudstrap') && !email.includes('@sashido');

    return isTrial;
  }

  renderTrialBox = () => {
    const { currentCustomer } = this.props;
    const { next_billing_at } = currentCustomer.subscription;
    const { has_payment_method } = currentCustomer;

    const shouldRender = this.isTrialFn();

    if (!shouldRender) {
      return null;
    }

    const days_left = next_billing_at ? moment.unix(next_billing_at).utc().diff(moment(), 'days') : null;

    return (
      <div className={styles.trial} onClick={this.addCard}>
        <div className={styles.left}>
          <span className={styles.days}>
            {days_left}
            <span>days</span>
          </span>
        </div>
        <div className={styles.right}>
          <p>Your Trial period will end soon.</p>
          {has_payment_method ? null : <p>Add your credit card to manage your apps without interruption.</p>}
        </div>
      </div>
    );
  }

  renderBanners = () => {
    const { router } = this.props;
    const { params = {} } = router || {};
    const { appId } = params;
    const shouldRender = this.isTrialFn();

    if (shouldRender || !appId) {
      return null;
    }

    const onClickHandler = () => {

      history.push(`/products/apps/${appId}/runtime/engine`)

      GoogleTagManager({
        data: {
          event: 'sidebar-engines-tuning',
          pageCategory: 'upsale',
        },
      });
    }

    return (
      <div
        className={styles.banner}
      >
        <div>
          <h3>Tune your app<br />Performance &amp; Stability</h3>
          <p>Deploy with Zero-Downtime, make your requests fly, and keep your users even happier.</p>
          <br />
          <p><strong>Try now our new Engines and High Availability features.</strong></p>
          <Button color='green' value='Tune your app' onClick={onClickHandler} />
        </div>
      </div>
    );
  }

  render() {
    const { currentCustomer } = this.props;

    let classes = [styles.content, 'pg-pe'];

    if(currentCustomer.is_trial) {
      classes.push(styles.hasTrial);
    }

    return (
      <div className={styles.sidebar} ref='sidebar'>
        <SidebarHeader />

        <div className={styles.h}>

          {this.props.appSelector ? <AppsSelector {...this.props} /> : null}

          <div className={classes.join(' ')}>
            {this.props.sections.map((section) => {
              let active = section.name === this.props.section;

              return (
                <SidebarSection
                  key={section.name}
                  name={section.name}
                  icon={section.icon}
                  style={section.style}
                  link={(this.props.prefix || '') + section.link}
                  active={active}
                  newFeature={section.newFeature}
                  betaFeature={section.betaFeature}
                >
                  {active ? this._subMenu(section.subsections) : null}
                </SidebarSection>
              );
            })}
          </div>

          {this.renderTrialBox()}
          {this.renderBanners()}
        </div>
        <SidebarUserMenu />
      </div>
    );
  }
}

Sidebar.contextTypes = {
  generatePath: PropTypes.func
};
